import swal from "sweetalert2";
import api from "services/api";
import { __ } from "services/Translator";

/**
 * Activation gate. With login_timing = 'after_verification' the backend answers
 * HTTP 423 to /login until the player has clicked the activation link in their
 * email. That is not a failed login, so it gets its own message plus a one-click
 * resend instead of the generic "Login Failed" alert.
 */

export const ACTIVATION_REQUIRED_STATUS = 423;

export const isActivationRequired = (response) =>
  response?.status === ACTIVATION_REQUIRED_STATUS;

const resendActivationEmail = async (email) => {
  const response = await api.post("/resend-activation-mail", { email });
  if (response.status === 200) {
    await swal.fire({
      icon: "success",
      title: __("Email sent"),
      text: __("Check your inbox for a new activation link."),
    });
    return;
  }
  await swal.fire({
    icon: "error",
    title: __("We could not send the email"),
    text:
      response.data?.message ||
      __("Please try again in a moment, or contact support."),
  });
};

export const showActivationRequiredNotice = async (email) => {
  const result = await swal.fire({
    icon: "info",
    title: __("Confirm your email first"),
    text: __(
      "We sent you an activation link. Please click it to activate your account, then log in."
    ),
    showCancelButton: true,
    confirmButtonText: __("Resend email"),
    cancelButtonText: __("Close"),
  });

  if (result.isConfirmed && email) {
    await resendActivationEmail(email);
  }
};
